// extracted by mini-css-extract-plugin
export default {"container":"uddfVM","title":"o7Me2Y","text":"NIU3CR"};